class ProductLengthsTabs extends HTMLElement {
  connectedCallback () {
    this.lengthSelectors = this.querySelectorAll('[data-product-length-controls]')
    this.lengthContainers = this.querySelectorAll('[data-product-length-container]')
    this.productPdpProperty = document.querySelector('[data-pdp-length-property]')
    this.productPdpTitle = document.querySelector('[data-pdp-product-title]')
    this.submitButton = document.querySelector('.product-form__submit')

    this.lengthSelectors.forEach(selector => {
      selector.addEventListener('click', this.changeContainer.bind(this))
    })
  }

  changeContainer (event) {
    const clicked = event.target
    if (clicked.classList.contains('prd-LengthSelector_selected')) return

    const selectedId = clicked.dataset.productLengthControls

    this.lengthSelectors.forEach(selector => {
      selector.classList.toggle(
        'prd-LengthSelector_selected',
        selector.dataset.productLengthControls === selectedId,
      )
    })

    if (this.productPdpTitle) {
      this.productPdpTitle.innerHTML = clicked.dataset.productLengthTitle
    }
    if (this.productPdpProperty) {
      this.productPdpProperty.value = clicked.dataset.productLengthLabel
    }

    document.querySelector('.gPreorderProductId')?.setAttribute('value', selectedId)
    document.querySelector('form[data-preorder-product-id]')?.setAttribute('data-preorder-product-id', selectedId)

    this.lengthContainers.forEach(container => {
      const isSelected = container.dataset.productLengthContainer === selectedId
      container.setAttribute('aria-hidden', !isSelected)

      if (isSelected) {
        container.querySelectorAll('input[type="radio"]').forEach(radio => {
          radio.checked = false
        })
      }
    })

    if (this.submitButton) {
      this.submitButton.setAttribute('disabled', true)
      this.submitButton.querySelector('span').innerHTML = window.productFormStrings.selectSize
    }
  }
}

customElements.define('product-lengths-tabs', ProductLengthsTabs)
